import { projectUrlWithParams } from '../../../../routes';
import type { Language, Task } from './taskTypes';

export const getProjectUrl = (task: Task, view: 'single' | 'multi', language?: Language, taskUncompleted?: boolean) =>
    projectUrlWithParams({
        projectId: task.master_project_id,
        view,
        singleLangId: language?.lang_id,
        filter: `task_${taskUncompleted ? 'uncompleted_' : ''}${task.id}`,
        ...(task.master_branching_enabled ? { branch: task.branch_name ? task.branch_name : 'master' } : {}),
    });
